export default __webpack_public_path__ + "maps-examples-add-marker-symbol-1200-9b5622ad251e15aa79c1900ba99c9672.png";